module.exports = __webpack_public_path__ + "img/checkmark-outline.62b216b3.svg";